import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { UncontrolledPopover, PopoverBody, PopoverHeader } from 'reactstrap';
const WhatsThis = _ref => {
  let text = _ref.text,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'What\'s this?' : _ref$title;
  const _useState = useState("id-".concat(uuid())),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  const styles = {
    cursor: 'help',
    outline: 0
  };
  const shortTitle = typeof text === 'string' ? kebabCase(text.substring(0, 10)) : 'whatsthis';
  const className = "fas fa-info-circle ".concat(shortTitle);
  return /*#__PURE__*/React.createElement("i", {
    className: className,
    style: styles,
    id: id,
    role: "button",
    tabIndex: 0,
    onKeyDown: () => {}
  }, /*#__PURE__*/React.createElement(UncontrolledPopover, {
    trigger: "legacy",
    placement: "top",
    target: id
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, title), /*#__PURE__*/React.createElement(PopoverBody, {
    style: {
      padding: 5,
      textAlign: 'center'
    }
  }, text)));
};
WhatsThis.propTypes = {
  title: PropTypes.string,
  text: PropTypes.node.isRequired
};
export default WhatsThis;